import moment from 'moment';

export const getMaxClaimDate = (claim) => {
	return moment(claim?.created_at).add(14, 'days').format('DD.MM.YYYY');
};
